import PropTypes from 'prop-types';

export const User = PropTypes.shape({
  firstName: PropTypes.string,
  lastName: PropTypes.string,
  avatar: PropTypes.string,
});
